import { createContext } from "preact";
import { useContext } from "preact/hooks";

export const Theme = createContext({
  isDark: false,
  setIsDark: () => null,
});

export const useTheme = () => useContext(Theme);
